import { queryOptions } from "@tanstack/react-query";
import {
  getMetricsSummary,
  getMetricSeries,
  addMeasurement,
  type Api,
} from "api-client";

import { type MetricsRepository } from "./MetricsRepository";

export function createPrivateMetricsRepository(): MetricsRepository {
  return {
    queryKey: ["metrics", "private"],
    summaryOptions(athleteId) {
      return queryOptions<Api.GetMetricsSummary.Output.Self>({
        queryKey: ["metrics", "private", athleteId],
        async queryFn() {
          return (await getMetricsSummary({ query: { athleteId } })).data.data;
        },
      });
    },
    seriesOptions(input) {
      return queryOptions<Api.GetMetricSeries.Output.Self>({
        queryKey: [
          "metrics",
          "private",
          "series",
          input.userId ?? "me",
          input.metricId,
          input.view,
        ],
        async queryFn() {
          return (
            await getMetricSeries({
              path: { id: input.metricId },
              query: { view: input.view, userId: input.userId },
            })
          ).data.data;
        },
      });
    },
    async addMeasurement({ athleteId: _athleteId, ...body }) {
      return (await addMeasurement({ body })).data.data;
    },
  };
}
